import type { ReactNode } from 'react'
import { cn } from '@nwwp/ui-shadcn'
import { LINKS } from '~/utils/links'

export function PhoneDisclosureBody() {
  return (
    <>
      <strong>Terms and Disclosures</strong>
      <br />I acknowledge and agree to NerdWallet Wealth Partner&apos;s{' '}
      <a href={LINKS.TERMS_OF_USE} target="_blank" rel="noopener noreferrer" className="underline">
        Terms of Use
      </a>{' '}
      and{' '}
      <a href={LINKS.PRIVACY_POLICY} target="_blank" rel="noopener noreferrer" className="underline">
        Privacy Policy
      </a>
      , and confirm receipt of NerdWallet Wealth Partner&apos;s{' '}
      <a href={LINKS.ADV_2A} target="_blank" rel="noopener noreferrer" className="underline">
        Form ADV Part 2A
      </a>{' '}
      and{' '}
      <a href={LINKS.FORM_CRS} target="_blank" rel="noopener noreferrer" className="underline">
        Form CRS
      </a>
      .
      <br />
      <br />
      <strong>Consent to Marketing Calls and Texts</strong>
      <br />I provide my express written consent to receive marketing calls and text messages at the phone number I
      provided above from NerdWallet Wealth Partners, including their agents and service providers. These communications
      may be sent by using automated technology, including an autodialer, selection system, or prerecorded or artificial
      voice. I provide this consent even if my number is listed on any company-specific, state, or federal Do-Not-Call
      list, or if I have previously opted out of receiving telemarketing calls or text messages from NerdWallet. I
      understand that I may opt out of receiving calls or text messages at any time.
      <br />
      <br />I certify that the phone number I provided is my own and I am permitted to receive calls and texts at that
      number, and I agree to promptly notify NerdWallet Wealth Partners if I stop using the number entered above.
      Message and data rates may apply. Consent is not required as a condition of using these services.
    </>
  )
}

export function PhoneDisclosure({
  ctaText,
  children,
  className,
  ctaPlacement = 'below',
}: {
  ctaText: string
  children?: ReactNode
  /** Overrides the default `text-body-sm` sizing; cn() resolves the font-size conflict. */
  className?: string
  /** Where the submit button sits relative to this disclosure. Defaults to below, matching every other form. */
  ctaPlacement?: 'below' | 'above'
}) {
  return (
    <div className={cn('text-body-sm', className)}>
      By clicking &ldquo;{ctaText}&rdquo; {ctaPlacement}, I agree to the following:
      <br />
      <br />
      {children ?? <PhoneDisclosureBody />}
    </div>
  )
}
